<div *ngIf="isLoading" class="loading">
  <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
</div>

<con-page-layout>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
    <h2>{{ 'aat_title' | translate }}</h2>
    <div fxFlex></div>
  </div>
  <div class="sub-title">{{ 'aat_subTitle' | translate }}</div>
  <br />
  <con-page-layout-content fxLayout="column" fxLayoutGap="16px">
    <div fxLayout="row" fxLayoutAlign="start center">
      <app-account-selector-input-async 
      (loadingSpinner)="loadingSpinner($event)"
      (selected)="accountChanged($event)" 
      (cleared)="accountCleared()">
      </app-account-selector-input-async>
    </div>

    <form (ngSubmit)="update()" #form="ngForm" novalidate *ngIf="accountSelectedId > 0">
      <div class="flexColumn">

        <mat-form-field appearance="fill">
          <mat-label>{{ 'aat' | translate }}</mat-label>
          <textarea type="text" name="aat_title" rows="4" matInput #aat_title="ngModel" placeholder="" required
            [(ngModel)]="aat" minlength="470" maxlength="500">
          </textarea>
          <mat-hint>Minimum characters 470, {{aat == null ? 0 : aat?.length}}/500 Characters</mat-hint>
          <mat-error *ngIf="aat_title.hasError('required')">{{ 'aat_required' | translate }}</mat-error>
          <mat-error *ngIf="aat_title.hasError('minlength')">{{ 'aat_minLength' | translate }}</mat-error>
        </mat-form-field>
  
      </div>
  
      <div fxLayout="row warp" fxLayoutAlign="end start" fxLayoutGap="16px">
        <div>
          <a type="button" mat-raised-button (click)="cancel()">{{ 'cancel' | translate }}</a>
        </div>
        <div>
          <button type="submit" *ngIf="isAdministrator" mat-raised-button color="primary" [disabled]="form.invalid">{{ 'save' | translate }}</button>
        </div>
      </div>
    </form>

  </con-page-layout-content>
</con-page-layout>